import BranchDetails from "./branches/BranchDetails";
import BranchElement from "./branches/BranchElement";
import { branchcontext } from "../../../../context/intro/branch/branchcontext";
import styled from "styled-components";
const Branches = ({ selectedBranch, setSelectedBranch }) => {
  return (
    <Div name="branchSection">
      <BranchList>
        <div className="title">지점 선택</div>
        <div className="list">
          {branchcontext?.map((x) => (
            <BranchElement
              key={x.location}
              location={x.location}
              setLocation={setSelectedBranch}
              selectedBranch={selectedBranch}
            />
          ))}
        </div>
      </BranchList>
      <BranchDetails
        detail={branchcontext?.find((x) => x.location === selectedBranch)}
      />
    </Div>
  );
};
export default Branches;
const Div = styled.div`
  display: grid;
  grid-template-columns: 12rem minmax(0, 1fr);
  gap: 1.5rem;
  align-items: start;
  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const BranchList = styled.div`
  position: sticky;
  top: calc(5rem + 1rem);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 1.25rem;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.line};
  & > div.title {
    padding: 0.25rem 0.5rem 0.75rem;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  }
  & > div.list {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  @media (max-width: 767px) {
    position: static;
    & > div.list {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;
